<template>
  <div v-for="(leg, index) in hotels.route" :key="index" class="item">
    <div class="line">
      <span>{{ leg.place.name }}</span>
      {{ getDateFlightfox(leg.checkin) }}
    </div>
    <div class="line"><span>Stay</span>{{ getDurationAccommodationNights(leg.checkin, leg.checkout) }}</div>
    <div v-for="(room, j) in leg.rooms" :key="j" class="line">
      <span>People{{ leg.rooms.length > 1 ? " (" + (j + 1) + " room)" : "" }}</span>
      {{ room.adults }}
    </div>
  </div>
</template>

<script setup>
import DateTime from "../utils/datetime.js";

defineProps(["hotels"]);

const { getDateFlightfox, getDurationAccommodationNights } = DateTime();
</script>
